export default __webpack_public_path__ + "static/media/NBACK_ICONA.e78ca73b.svg";